export default "__VITE_ASSET__XfjU4lQV__"